import { render, staticRenderFns } from "./NowhowDropdown.vue?vue&type=template&id=4d9edd99"
import script from "./NowhowDropdown.vue?vue&type=script&lang=ts"
export * from "./NowhowDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports